import { useQueryClient } from '@tanstack/react-query';
import { API_QUERY_KEYS } from 'consts';
import { getDocument } from '../requests';

/**
 * Hook to update the key of a document collection query
 */
export const useUpdateDocumentCollectionKey = () => {
  const queryClient = useQueryClient();

  return async (documentId: number) => {
    const queries = queryClient.getQueriesData({});
    const document: any = await queryClient.ensureQueryData(
      [API_QUERY_KEYS.document, { documentId }],
      {
        queryFn: () => getDocument({ documentId: documentId! }),
      },
    );

    // refetch all documents queries
    queries.forEach((query: any) => {
      if (
        query[0][0] === API_QUERY_KEYS.documentCollection &&
        Array.isArray(query[0][1]) &&
        query[0][1].map(id => `${id}`).includes(`${documentId}`)
      ) {
        const data: any[] = query[1];

        if (data && Array.isArray(data)) {
          const newData = data.map((item: any) =>
            `${item.documentId}` === `${documentId}`
              ? {
                  documentId: document.id,
                  data: document,
                }
              : item,
          );

          queryClient.setQueryData(query[0], newData);
        }
      }
    });
  };
};
